import React, { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import ContentCard from "../../../components/misc/ContentCard";
import Dropdown, { DropdownValue } from "../../../components/misc/Dropdown";
import { getInternodeRoutes } from "../../../redux/api/expedition.api";
import {
  fetchCargoCarPickupCargoInternodeRoute,
  fetchNodesByInternodRoute,
} from "../../../redux/api/raports.api";
import CustomButton from "../../../components/CustomButton";
import SvgIcon from "../../../helpers/SvgIcon";
import LoadingIndicator from "../../../components/misc/LoadingIndicator";
import PackagesTable from "./components/PackagesTable";
import BinsTable from "./components/BinsTable";

import { clearPickupCargoInternodeRoute } from "../../../redux/reducer/raports.reducer";
import ClosePackageCargoInternodeModal from "./components/ClosePackageCargoInternodeModal";

function PickupCargoInternodeRoute() {
  const dispatch = useAppDispatch();

  const {
    raports: {
      pickupCargoInternodeRoute: {
        data: pickupCargoInternodeRouteData,
        isLoading: isLoadingPickupCargoInternodeRoute,
      },

      nodesByInternodRoute: {
        data: { data: nodesByInternodRoute },
      },
    },
    expedition: {
      internodeRoutes: {
        data: { data: internodeRoutes },
      },
    },
  } = useAppSelector((state) => ({
    raports: state.raports,
    expedition: state.expedition,
  }));

  const [selectedInternodeRoute, setSelectedInternodeRoute] =
    useState<DropdownValue | null>(null);
  const [selectedCurrentNode, setSelectedCurrentNode] =
    useState<DropdownValue | null>(null);
  const [selectedStartNode, setSelectedStartNode] =
    useState<DropdownValue | null>(null);
  const [selectedDestinationNode, setSelectedDestinationNode] =
    useState<DropdownValue | null>(null);

  const [activeCard, setActiveCard] = useState<string | number | null>(null);

  useEffect(() => {
    dispatch(
      getInternodeRoutes({
        page: 1,
        perPage: 1000,
      }),
    );

    dispatch(
      fetchNodesByInternodRoute({
        id_ruta_intranod: selectedInternodeRoute?.id,
      }),
    );
  }, [dispatch, selectedInternodeRoute?.id]);

  useEffect(() => {
    return () => {
      dispatch(clearPickupCargoInternodeRoute());
    };
  }, [dispatch]);

  const nodesByInternodRouteList = useMemo(
    () =>
      nodesByInternodRoute?.map((item) => ({
        label: item.nodNume,
        id: item.id_nod,
      })),
    [nodesByInternodRoute],
  );

  const internodeRouteNodesList = useMemo(
    () =>
      internodeRoutes?.map((item) => ({
        label: item.denumire,
        id: item.id_ruta_intranod,
      })),
    [internodeRoutes],
  );

  const handleSearch = () => {
    setActiveCard(null);

    if (
      selectedInternodeRoute &&
      selectedCurrentNode &&
      selectedStartNode &&
      selectedDestinationNode
    ) {
      dispatch(
        fetchCargoCarPickupCargoInternodeRoute({
          id_ruta_intranod: selectedInternodeRoute?.id,
          id_nod_curent: selectedCurrentNode?.id,
          id_nod_start: selectedStartNode?.id,
          id_nod_stop: selectedDestinationNode?.id,
        }),
      );
    }
  };

  const selectedNode = useMemo(() => {
    return pickupCargoInternodeRouteData.find(
      (item) => item.id_nod_destinatie === activeCard,
    );
  }, [pickupCargoInternodeRouteData, activeCard]);

  const currentPackages = selectedNode?.colete || [];
  const currentBins = selectedNode?.binuri || [];

  return (
    <div>
      <ContentCard cardTitle="Ridicare marfa pe ruta internod">
        <div className="d-flex align-items-center">
          <Dropdown
            title="Ruta internod"
            className="me-2"
            data={internodeRouteNodesList}
            singleValue={selectedInternodeRoute}
            setSingleValue={setSelectedInternodeRoute}
          />

          <Dropdown
            title="Nod curent"
            className="me-2"
            data={nodesByInternodRouteList}
            singleValue={selectedCurrentNode}
            setSingleValue={setSelectedCurrentNode}
          />

          <Dropdown
            title="Nod start"
            className="me-2"
            data={nodesByInternodRouteList}
            singleValue={selectedStartNode}
            setSingleValue={setSelectedStartNode}
          />

          <Dropdown
            title="Nod destinatie"
            className="me-2"
            data={nodesByInternodRouteList}
            singleValue={selectedDestinationNode}
            setSingleValue={setSelectedDestinationNode}
          />

          <CustomButton
            variant="contained"
            style={{ height: 50, width: 100, marginLeft: 10 }}
            onClick={handleSearch}>
            Cauta
          </CustomButton>
        </div>
      </ContentCard>

      {isLoadingPickupCargoInternodeRoute && (
        <div className="d-flex justify-content-center align-items-center">
          <LoadingIndicator />
        </div>
      )}

      {pickupCargoInternodeRouteData.length === 0 && (
        <ContentCard className="text-center  mt-2 ">
          <h2> Nu exista marfa</h2>
        </ContentCard>
      )}

      <div>
        {pickupCargoInternodeRouteData.length > 0 &&
          !isLoadingPickupCargoInternodeRoute && (
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
              {pickupCargoInternodeRouteData.map((item) => {
                const handleShowCargo = () => {
                  if (item.id_nod_destinatie) {
                    setActiveCard(item.id_nod_destinatie);
                  }
                };

                return (
                  <div key={item.id} className="col-12 col-md-6 col-lg-3 ">
                    <ContentCard
                      isLoading={isLoadingPickupCargoInternodeRoute}
                      cardTitle={item.denumireNod}
                      className={`${
                        activeCard === item.id_nod_destinatie
                          ? "border border-primary border-2"
                          : "border border-2"
                      } cursor-pointer`}
                      onClick={handleShowCargo}>
                      <div className="d-flex align-items-center justify-content-between py-2 border-bottom">
                        <p className="fs-5 mb-0 fw-bolder ">
                          Binuri x{" "}
                          <span className="text-danger fw-bolder">
                            {item.countBinuri}
                          </span>
                        </p>

                        <CustomButton
                          variant="contained"
                          tooltipTitle="Vezi marfa"
                          onClick={handleShowCargo}>
                          <SvgIcon type="PACKAGES" fill="white" />
                        </CustomButton>
                      </div>

                      <div className="d-flex align-items-center justify-content-between py-2">
                        <p className="fs-5 mb-0 fw-bolder ">
                          Colete x{" "}
                          <span className="text-danger fw-bolder">
                            {item.countColete}
                          </span>
                        </p>
                      </div>
                    </ContentCard>
                  </div>
                );
              })}
            </div>
          )}
      </div>

      {currentBins.length > 0 && (
        <ContentCard>
          <BinsTable bins={currentBins} />
        </ContentCard>
      )}

      {currentPackages.length > 0 && (
        <ContentCard>
          <PackagesTable packages={currentPackages} />
        </ContentCard>
      )}

      <ClosePackageCargoInternodeModal
        id_ruta_intranod={selectedInternodeRoute?.id}
        id_nod_curent={selectedCurrentNode?.id}
        id_nod_start={selectedStartNode?.id}
        id_nod_stop={selectedDestinationNode?.id}
      />
    </div>
  );
}

export default PickupCargoInternodeRoute;
